goog.provide('el8.data.currUser');

goog.require('el8.data.practiceUsers');
goog.require('el8.data.model.user');
goog.require('el8.model.base');
goog.require('el8.util.workspace');


el8.data.currUser = (function() {

    function filterDelegatesInWorkspace(delegateIds) {
        return delegateIds.map(function (id){
            return el8.data.practiceUsers.getByStaffId(id)
        }).filter(el8.util.workspace.workspaceFilter)
        .map(function (user){
            return user.getStaffId()
        })
    }

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8.data.model.user);

    // Info
    _class.addStringProperty('email');

    // Onboarded state
    _class.addBoolean('emailVerified');
    _class.addBoolean('credentialed');
    _class.addBoolean('practiceAuthenticated');
    _class.addBoolean('selfOnboarding');
    _class.addBoolean('credentialDocumentsUploaded');
    _class.addBoolean('practiceAdmin');

    // Preferences
    _class.addIntProperty('defaultStaffGroupId');
    _class.addIntProperty('cdsDrugDrugAlertLevel');
    _class.addIntProperty('cdsDrugAllergyAlertLevel');
    _class.addIntProperty('defaultPhysicianUserId');
    _class.addStringProperty('emailNotifications');
    _class.addIntProperty('unreadProviderLetterNotifications');
    _class.addIntProperty('unreadPatientLetterNotifications');
    _class.addIntProperty('unreadReferralNotifications');

    _class.addBoolean('allowStaffToSendReferrals');

    _class.addIntProperty('primaryPrintHeaderId');
    _class.addIntProperty('defaultErxServiceLocationId');

    // CDS preferences
    _class.addBoolean('cdsEnabled');
    _class.addBoolean('cdsDisplaySupDiag');
    _class.addProperty('decisionSupportsEnabled');

    // The keys of this dictionary will be delegate permission types
    // (corresponding to DELEGATE_PERMISSION_TYPES in practicians/models.py).
    // The values will be lists of physician ids.
    _class.addProperty('delegatingPhysicianIdsMap', false, {});

    // Holds state
    _class.addBoolean('showCdsDrugAllergyAlert');

    _class.addBoolean('showDualCodingEnabled');
    _class.addBoolean('structuredAssessmentsEnabled');

    // Vendor xor facility. Enforced in view
    _class.addIntProperty('defaultLabVendorId');
    _class.addIntProperty('defaultLabFacilityId');


    _class.prototype.loadEpcsStatus = function(defer) {

        var loadfn = function() {
            $.el8_ajax({
                type: 'GET',
                async: Boolean(defer),
                url: el8.service.urls.get('epcsRegistrationCheck'),
                success: function(data) {
                    el8.data.currUser.setEpcsEnabled(data);
                }
            });
        };

        if (defer) {
            _.defer(loadfn);
        }
        else {
            loadfn();
        }
    }
    _class.prototype.isEpcsEnabled = function() {
        // Lazy-loads EPCS status if we don't have it yet
        if (this['_epcsEnabled'] == null) {
            this.loadEpcsStatus(false);
            return this['_epcsEnabled'];
        }
        else {
            return this['_epcsEnabled'];
        }
    }

    _class.prototype.setEpcsEnabled = function(val) {
        this['_epcsEnabled'] = val;
    }

    _class.prototype.isCdsMeasureEnabled = function(nqfCode) {
        // takes as arg a single nqf code
        return _.contains(this.getDecisionSupportsEnabled(), nqfCode);
    };

    _class.prototype.enableCdsMeasure = function(successCb, nqfCode) {
        this.updatePreferencesCDScode(successCb, nqfCode, true);
    };
    _class.prototype.disableCdsMeasure = function(successCb, nqfCode) {
        this.updatePreferencesCDScode(successCb, nqfCode, false);
    };

    _class.prototype.getUnreadLetterNotifications = function(letterType) {
        // helper method to get letter notification settings
        if (letterType === el8.util.consts.CONSULTANT_LETTER) {
            return this.getUnreadProviderLetterNotifications();
        }
        if (letterType === el8.util.consts.PATIENT_LETTER) {
            return this.getUnreadPatientLetterNotifications();
        }
        if (letterType === el8.util.consts.REFERRAL_LETTER) {
            return this.getUnreadReferralNotifications();
        }
        return null;
    };

    _class.prototype.getRxDelegatingPhysicianIds = function() {
        return this.getDelegatingPhysicianIdsMap().rxs || [];
    };
    _class.prototype.getRxDelegatingPhysicianIdsInWorkspace = function() {
        var ret = this.getRxDelegatingPhysicianIds();
        return !el8.util.workspace.isInEffect() ?  ret :
            filterDelegatesInWorkspace(ret)
    };
    _class.prototype.getOrderDelegatingPhysicianIds = function() {
        return this.getDelegatingPhysicianIdsMap().orders || [];
    };
    _class.prototype.getOrderDelegatingPhysicianIdsInWorkspace = function() {
        var ret = this.getOrderDelegatingPhysicianIds();
        return !el8.util.workspace.isInEffect() ?  ret :
            filterDelegatesInWorkspace(ret)
    };
    _class.prototype.getBillDelegatingPhysicianIds = function() {
        return this.getDelegatingPhysicianIdsMap().bills || [];
    };

    _class.prototype.updatePreferencesCDScode = function(successCb, theCode, isEnabled) {
        var that = this;
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('userPrefsCDS') + theCode + '/',
            data: JSON.stringify(isEnabled),
            success: function(data) {
                that.populate(data);
                if (successCb) { successCb(); }
            }
        });
    };

    _class.prototype.updatePreferencesCDS = function(successCb) {
        var mapped = {};
        mapped['cds_drug_drug_alert_level'] = this.getCdsDrugDrugAlertLevel();
        mapped['cds_drug_allergy_alert_level'] = this.getCdsDrugAllergyAlertLevel();
        mapped['cds_enabled'] = this.isCdsEnabled();
        mapped['cds_display_sup_diag'] = this.isCdsDisplaySupDiag();
        mapped['decision_supports_enabled'] = this.getDecisionSupportsEnabled();

        var that = this;
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('userPrefsCDS'),
            data: JSON.stringify(mapped),
            success: function(data) {
                that.populate(data);
                if (successCb) { successCb(); }
            }
        });
    };

    _class.prototype.updatePreferences = function(successCb) {
        var mapped = {};
        mapped['default_staff_group_id'] = this.getDefaultStaffGroupId();
        mapped['default_physician_user_id'] = this.getDefaultPhysicianUserId();
        mapped['email_notifications'] = this.getEmailNotifications();
        mapped['unread_provider_letter_notifications'] = this.getUnreadProviderLetterNotifications();
        mapped['unread_patient_letter_notifications'] = this.getUnreadPatientLetterNotifications();
        mapped['unread_referral_notifications'] = this.getUnreadReferralNotifications();
        mapped['allow_staff_to_send_referrals'] = this.isAllowStaffToSendReferrals();
        mapped['primary_print_header_id'] = this.getPrimaryPrintHeaderId();
        mapped['default_erx_service_location_id'] = this.getDefaultErxServiceLocationId();
        mapped['show_dual_coding_enabled'] = this.isShowDualCodingEnabled();
        mapped['structured_assessments_enabled'] = this.isStructuredAssessmentsEnabled();
        mapped['default_lab_vendor_id'] = this.getDefaultLabVendorId();
        mapped['default_lab_facility_id'] = this.getDefaultLabFacilityId();

        var that = this;
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('userPrefs'),
            data: {data: JSON.stringify(mapped)},
            success: function(data) {
                that.populate(data);
                if (successCb) { successCb(); }
            }
        });
    };

    _class.prototype.getDefaultPhysicianId = function() {
        if (this.getDefaultPhysicianUserId()) {
            var pUser = el8.data.practiceUsers.getById(this.getDefaultPhysicianUserId());
            return pUser.getStaffId();
        }
        return null;
    };

    return new _class({});

})();
